import { Injectable } from '@angular/core';
import { BaseChartService } from '../base-chart/base-chart.service';
import { GenericPieChartSettings } from '../models/generic-chart-settings/generic-pie-chart-settings';

@Injectable({
  providedIn: 'root',
})
export abstract class BasePieChartService extends BaseChartService<GenericPieChartSettings> {}
